<template>
  <div>
    <cart-component />
  </div>
</template>

<script>
import CartComponent from '@/components/CartComponent.vue';
export default {
  name: "CartPage",
  components: { CartComponent },
};
</script>

<style scoped>
</style>

